import { getWorkOrderDetails } from '@/services/rc/work-orders.service'
import { useQuery } from '@tanstack/vue-query'

export const useWorkOrderDetails = (workOrderNumber: string) =>
  useQuery({
    queryKey: ['work-orders', workOrderNumber],
    queryFn: () => getWorkOrderDetails(workOrderNumber),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  })
